<template>
  <form
    class="base-search-with-button"
    itemprop="potentialAction"
    itemscope
    itemtype="https://schema.org/SearchAction"
    @click.stop
    @submit.prevent="onSearch"
  >
    <input
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      type="text"
      itemprop="query-input"
      @input="$emit('update:value', ($event.target as HTMLInputElement).value)"
    />
    <button class="animated-search-button" type="button" @click="onSearch">
      <BaseIconSvoi class="search-icon" icon="search/search-normal" size="m" />
      <span class="search-text">{{ buttonText }}</span>
    </button>
  </form>
</template>

<script lang="ts" setup>
  import { BaseIconSvoi } from '~/components/base-ui/icon'

  interface Props {
    inputId?: string
    value?: string
    buttonText?: string
    placeholder?: string
  }

  withDefaults(defineProps<Props>(), {
    inputId: 'global-search-input',
    value: '',
    buttonText: 'Найти',
    placeholder: 'Поиск по разделу',
  })

  const emit = defineEmits<{
    (e: 'update:value', value: string): void
    (e: 'on-search'): void
  }>()

  const onSearch = () => {
    emit('on-search')
  }
</script>

<style lang="scss" scoped>
  .base-search-with-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
    height: 48px;
    padding: 2px;
    border: 2px solid $main-back-color;
    border-radius: 100px;
    background: $main-back-color;
    transition: $trans-default;

    @include vp-1439 {
      width: 100%;
    }

    input {
      width: calc(100% - 55px);
      height: 100%;
      margin: 0;
      padding: 0 0 0 23px;
      font-size: 16px;
      line-height: 20px;
      border: none;
      border-radius: 100px;
      background-color: transparent;

      &:focus {
        outline: none;
      }
    }

    > .animated-search-button {
      position: relative;
      display: flex;
      align-items: center;
      height: 40px;
      width: 62px;
      padding: 0 16px;
      transition: $trans-default;
      border-radius: 100px;
      border-color: transparent;
      background: $main-back-color;
    }

    > .animated-search-button > .search-icon {
      color: $color-black-50;
      transition: color $trans-default;
    }

    > .animated-search-button > .search-text {
      position: absolute;
      left: 0;
      display: block;
      font-weight: 500;
      color: $color-default-white;
      opacity: 0;
      transition: $trans-default;
    }

    @include hover-focus {
      border: 2px solid $color-kiwi-50;
    }

    &:focus-within {
      background: $color-default-white;
      border: 2px solid $color-kiwi-50;

      .animated-search-button {
        background: $color-kiwi-50;
        width: 110px;
      }

      .search-text {
        opacity: 1;
        left: 47px;
      }

      .search-icon {
        color: $color-default-white;
      }
    }
  }
</style>
